<template>
<div class="columns top-section">
  <div class="column is-two-thirds">

    <section class="block">
        <router-link tag="a" :to="{name: 'play', params: {slug: item.slug}}">
            <img :src="'/images/plays' + item.mainimage" :alt="item.title" class="img-fluid bordered-image">
        </router-link>
        
        <div class="block-with-vsmall-vertical-gap">
          <div>
              <h1 class="title featuredplay-title">{{ item.title }}</h1>
              <span class="featuredplay-message tag is-warning" v-if="item.message">{{ item.message }}</span>
          </div>

          <div>
              <p v-if="item.blurbExcerpt" v-html="item.blurbExcerpt" />
              <p v-else v-html="truncatedBlurb(item.blurb)" />
          </div>

          <div class="field is-grouped buttons block-with-medium-vertical-gap">
              <div class="control" v-if="item.buylink">
                  <a class="button is-primary" :href="item.buylink">Buy tickets</a>
              </div>
              <div class="control" v-if="isStatus('audition')">
                  <router-link :to="{name: 'play-audition', params: {slug: item.slug}}" class="button is-link">Apply to audition</router-link>
              </div>
              <div class="control">
                  <router-link :to="{name: 'play', params: {slug: item.slug}}" class="button is-transparent">Read more</router-link>
              </div>
          </div>

        </div>
    </section>
  </div>

  <aside class="column">

    <div class="block-with-small-vertical-gap-at-bottom" v-if="item.dates.displayedText && item.dates.displayedText.length > 0">
      <div class="is-pulled-left">
          <img src="/images/icons/iconClock.png" srcset="/images/icons/iconClock@2x.png 2x" />
      </div>
      <div class="no-image-wrap-small">
        <div class="block-with-small-vertical-gap-at-bottom" v-for="date in item.dates.displayedText" :key="date.startdate">
          <div class="dateAndVenueTitle">{{ date.title }}</div>
          <span class="dateAndVenueDescription">{{ date.description }}</span>
        </div>
      </div>
    </div> 

    <div class="block-with-small-vertical-gap-at-bottom" v-if="item.venues.length > 0">
      <div class="is-pulled-left">
          <img src="/images/icons/iconLocation.png" srcset="/images/icons/iconLocation@2x.png 2x" />
      </div>
      <div class="no-image-wrap-small">
        <div class="block-with-small-vertical-gap-at-bottom" v-for="venue in item.venues" :key="venue._id">
          <div class="dateAndVenueTitle">Venue</div>
          <span class="dateAndVenueDescription">{{ venue.name }}, {{ venue.address }}</span>
        </div>
      </div>
    </div> 

    <div class="block-with-small-vertical-gap-at-bottom" v-if="item.prices.length > 0">
      <div class="is-pulled-left">
          <img src="/images/icons/iconLocation.png" srcset="/images/icons/iconLocation@2x.png 2x" />
      </div>
      <div class="no-image-wrap-small">
        <div class="block-with-small-vertical-gap-at-bottom" v-for="price in item.prices" :key="price._id">
          <div class="dateAndVenueTitle">{{ price.title }}</div>
          <span class="dateAndVenueDescription">{{ price.price }}</span>
        </div>
      </div>
    </div> 

  </aside>

</div>
</template>

<script>
var moment = require('moment');
//import mixins from '@/mixins/mixins';
// import Api from '@/config/Api'; // MCH added

// import AlertMeButton from './AlertMeButton';
// import MaxPriceWidget from './MaxPriceWidget';

export default {
    props: ['item'],
    methods: {
        isStatus(s) {
          if (!this.item.status) return false;
          return this.item.status.includes(s);
        },
        prettifydate(date) {
            return moment(date).format("dddd, Do MMMM YYYY");
        },
        truncatedBlurb(blurb) {
            var output = this.$options.filters.truncate(blurb, 350)
            // | truncate(160, '...')
            return output;
        }
    }
    /* components: {
        ProductShopRows,
        ProductEventRows,
        AlertMeButton,
        MaxPriceWidget
    }, */
    //mixins: [mixins],
   
    /*MCH START*/
    /* data() {
        return {
            rrpPrice: '8',
            // pricey: '',
        }
    }, */
    /*created() {
        Api().get('/productGroups')
            .then(response => {
                // this.productGroups = response.data.productGroups;

                console.log("AA:",this.productGroup.rrpPrice); 
                //this.$set(this.productGroup, 'rrpPrice', 0);
                //console.log("BB:",this.productGroup.rrpPrice); 
            });
    }*/
    /*MCH END*/


}
</script>

<style scoped>

/* img.row-image {
  width: 62px;
  height: 62px;
} */
.product-image {
  vertical-align: top;
  display: inline-block;
}
/* .product-info {
  display: inline-block;
} */
</style>



// WEBPACK FOOTER //
// src/components/cards/WhatsonRow.vue